import { Pipe, PipeTransform } from '@angular/core';
import { AttachmentInterface } from '../../shared/interfaces';
import { PersonaType as IAMPersonaType } from '@vendasta/iam';
import { PersonaType } from '@vendasta/task-manager';

@Pipe({
  name: 'uploadedBy',
  standalone: true,
})
export class UploadedByPipe implements PipeTransform {
  transform(attachment: AttachmentInterface): string {
    return attachment?.uploadingPersonaType === IAMPersonaType.smb
      ? 'PROJECT_TRACKER.UPLOADED_BY_YOU'
      : 'PROJECT_TRACKER.UPLOADED_BY_FULFILLMENT_TEAM';
  }
}

@Pipe({
  name: 'canDeleteFile',
  standalone: true,
})
export class CanDeleteFilePipe implements PipeTransform {
  transform(attachment: AttachmentInterface, userPersona: string): boolean {
    return attachment?.filePermissions?.delete?.includes(convertUserPersona(userPersona));
  }
}

@Pipe({
  name: 'filterAndSortFulfillmentFiles',
  standalone: true,
})
export class FilterAndSortFulfillmentFiles implements PipeTransform {
  transform(attachments: AttachmentInterface[], userPersona: string): AttachmentInterface[] {
    userPersona = convertUserPersona(userPersona);
    return (
      attachments
        ?.filter((attachment) => attachment?.filePermissions?.read?.includes(userPersona))
        ?.sort(sortSmbFilesToEnd) || []
    );
  }
}

function sortSmbFilesToEnd(a: AttachmentInterface, b: AttachmentInterface): number {
  if (a.uploadingPersonaType === 'smb' && b.uploadingPersonaType !== 'smb') {
    return 1; // Move "smb" uploadingPersonaType to the end
  }
  if (a.uploadingPersonaType !== 'smb' && b.uploadingPersonaType === 'smb') {
    return -1; // Move "smb" uploadingPersonaType to the end
  }
  return 0; // Keep the order unchanged if both have the same uploadingPersonaType value
}

export function convertUserPersona(userPersona: string | PersonaType): IAMPersonaType {
  if (typeof userPersona === 'string') {
    return (
      [
        IAMPersonaType.smb,
        IAMPersonaType.digital_agent,
        IAMPersonaType.sales_person,
        IAMPersonaType.partner,
        IAMPersonaType.crm_role,
      ].find((persona) => persona.toString() === userPersona) || IAMPersonaType.smb
    );
  }
  switch (userPersona) {
    case PersonaType.PERSONA_TYPE_SMB:
      return IAMPersonaType.smb;
    case PersonaType.PERSONA_TYPE_DIGITAL_AGENT:
      return IAMPersonaType.digital_agent;
    case PersonaType.PERSONA_TYPE_SALES_PERSON:
      return IAMPersonaType.sales_person;
    case PersonaType.PERSONA_TYPE_PARTNER:
      return IAMPersonaType.partner;
    default:
      return IAMPersonaType.smb;
  }
}
